
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.65.241a1 1 0 00-.8-.23l-13 2a1 1 0 00-.85.99v10.35a3.451 3.451 0 00-3.444.24A3.5 3.5 0 107 16.501v-7.64l11-1.69v4.18a3.451 3.451 0 00-3.444.24A3.5 3.5 0 1020 14.501v-13.5a1 1 0 00-.35-.76zM3.5 18.001a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3zm13-2a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3zM18 5.141L7 6.831v-3l11-1.66v2.97z"}})])
          )
        }
      }
    